document.querySelectorAll('.pcm-swatch-input').forEach(function(input) {
  input.addEventListener('change', function() {
    const productId = this.getAttribute('data-product-id');
    const productImage = document.getElementById('pcm-img-' + productId);
    
    if (!productImage) {
      console.error('❌ Không tìm thấy ảnh product!');
      return;
    }

    // 🆕 AUTO-SELECT: Tự động chọn option đầu tiên cho các variant groups khác
    const currentIndex = this.getAttribute('data-index');
    const productCard = productImage.closest('.product-card-mini');
    const allSwatchGroups = productCard ? productCard.querySelectorAll('.pcm-swatches') : [];
    
    allSwatchGroups.forEach(function(group) {
      const groupIndex = group.getAttribute('data-index');
      const groupProductId = group.getAttribute('data-product-id');
      
      // Chỉ xử lý các variant groups khác (không phải cái đang onChange)
      if (groupProductId === productId && groupIndex !== currentIndex) {
        const checkedInput = group.querySelector('.pcm-swatch-input:checked');
        
        // Nếu chưa có gì được chọn, tự động chọn option đầu tiên
        if (!checkedInput) {
          const firstInput = group.querySelector('.pcm-swatch-input');
          if (firstInput) {
            firstInput.checked = true;
            console.log(`✅ Auto-selected first option in variant group ${groupIndex}`);
          }
        }
      }
    });

    // Lấy tất cả các option đã chọn (bao gồm cả auto-selected)
    const swatchGroups = document.querySelectorAll(`.pcm-swatches`);
    const selectedOptions = [];
    
    swatchGroups.forEach(function(swatchGroup) {
      const groupProductId = swatchGroup.getAttribute('data-product-id');
      
      if (groupProductId === productId) {
        const index = swatchGroup.getAttribute('data-index');
        const checkedInput = swatchGroup.querySelector('.pcm-swatch-input:checked');
        const optionValue = checkedInput ? checkedInput.getAttribute('data-option-value') : null;
        selectedOptions[index] = optionValue;
      }
    });

    // Lấy variant data từ JSON
    const variantDataElement = document.querySelector(`[data-product-variants="${productId}"]`);
    
    if (!variantDataElement) {
      console.error('❌ Không tìm thấy script JSON chứa variants!');
      return;
    }

    let variantsData;
    try {
      variantsData = JSON.parse(variantDataElement.textContent);
    } catch(e) {
      console.error('❌ Lỗi parse JSON:', e);
      return;
    }

    // Tìm variant khớp với TẤT CẢ options đã chọn
    const matchedVariant = variantsData.variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });

    if (!matchedVariant) {
      console.error('❌ Không tìm thấy variant khớp!');
      return;
    }

    if (!matchedVariant.featured_media) {
      console.error('⚠️ Variant không có featured_media!');
      return;
    }

    // 🆕 CẬP NHẬT VARIANT ID CHO HIDDEN INPUT
    const form = productCard ? productCard.querySelector('form[id^="product-form-"]') : null;
    const hiddenInput = form ? form.querySelector('.product-variant-id') : null;
    const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value');

    if (hiddenInput && form) {
      console.log('📋 Form:', form.id);
      console.log('📋 Before update:', hiddenInput.value);
      
      // Set value
      hiddenInput.setAttribute('value', matchedVariant.id);
      hiddenInput.value = matchedVariant.id;
      
      // 🔒 LOCK VALUE — KHÔNG CHO SHOPIFY GHI ĐÈ
      Object.defineProperty(hiddenInput, 'value', {
        configurable: true,
        get() {
          return originalDescriptor.get.call(this);
        },
        set(newValue) {
          // Block mọi attempt set value khác
          console.warn('🚫 Blocked Shopify auto-set:', newValue, '| Keeping:', matchedVariant.id);
          originalDescriptor.set.call(this, matchedVariant.id);
        }
      });
      
      console.log('✅ Updated and locked variant ID:', matchedVariant.id);
      console.log('🎯 FINAL product-variant-id:', hiddenInput.value);
    } else {
      console.warn('⚠️ Không tìm thấy form hoặc hidden input');
    }

    // Hiển thị loading
    const wrapper = productImage.closest('.pcm-image-wrapper');
    let oldSpinner = wrapper.querySelector('.spinner_img');
    if (oldSpinner) oldSpinner.remove();
    
    productImage.classList.add('loading-img');
    
    const spinnerHTML = `
      <div class="loading__spinner spinner_img">
        <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    wrapper.insertAdjacentHTML('beforeend', spinnerHTML);

    // Đổi ảnh
    const newImageSrc = matchedVariant.featured_media.src;
    productImage.src = newImageSrc;
    productImage.srcset = '';

    // Update text hiển thị option đang chọn cho TẤT CẢ variant groups
    allSwatchGroups.forEach(function(group) {
      const groupIndex = group.getAttribute('data-index');
      const groupProductId = group.getAttribute('data-product-id');
      
      if (groupProductId === productId) {
        const checkedInput = group.querySelector('.pcm-swatch-input:checked');
        const optionValueSpan = productCard ? productCard.querySelector(`.option-value[data-index="${groupIndex}"]`) : null;
        
        if (optionValueSpan && checkedInput) {
          optionValueSpan.textContent = checkedInput.getAttribute('data-option-value');
        }
      }
    });

    productImage.onload = function() {
      let spinner = wrapper.querySelector('.spinner_img');
      if (spinner) spinner.remove();
      productImage.classList.remove('loading-img');
    };
    
    productImage.onerror = function() {
      let spinner = wrapper.querySelector('.spinner_img');
      if (spinner) spinner.remove();
      productImage.classList.remove('loading-img');
    };
  });
});